import clsx from 'clsx'

export const Divider = ({ className }) => {
  return (
      <div className={clsx('flex w-px h-5 bg-neutral-medium', className)} />
  )
}
